
import { defineComponent } from 'vue'
import ContentBar from './ContentBar.vue'

export default defineComponent({
  components: { ContentBar },
  name: 'Navbar',
  data() {
    return {
      logo: require('@/assets/images/logo.png'),
      mobBar: require('@/assets/images/mobBar.svg'),
      showMobContent: false
    }
  },
  methods: {
    mobBarClick() {
      this.showMobContent = !this.showMobContent
    }
  }
})
